












import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import ChooseAddingPaymentMethod from '@/components/User/Wallet/ChooseAddingPaymentMethod.vue';

@Component({
    components: {
        ChooseAddingPaymentMethod,
    },
})

export default class ChooseAddingPaymentMethodOverlay extends Vue {
    public cancel() {
        this.$store.commit(Mutations.SET_CHOOSE_PAYMENT_METHOD_BLOCK_VISIBILITY, false);
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('general.my-wallet', 'My wallet'));    }

    public created() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('general.payment_methods', 'Payment Methods'));
    }
}
